var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar bg-base-color min-h-screen overflow-x-auto w-[110px] transition-[opacity,transform] md:opacity-100 md:translate-x-0 opacity-0 -translate-x-[110px]"},[_c('div',{staticClass:"sidebar-wrapper"},[_c('NavList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }